import RateYo from 'rateyo';
import 'rateyo/lib/es/rateyo.min.css';

const normalFill = '#fff';
const ratedFill = '#a2d13f';
const starSvg = `<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.05332 1.0305L10.1206 4.75751L10.237 4.96737L10.4735 5.00783L14.4733 5.69193L11.7239 8.93774L11.5858 9.10084L11.6082 9.31341L12.0218 13.2305L8.23683 11.7293L8.0525 11.6562L7.86816 11.7293L4.08318 13.2305L4.49676 9.31341L4.5192 9.10084L4.38105 8.93774L1.63172 5.69193L5.63145 5.00783L5.86789 4.96739L5.98431 4.75766L8.05332 1.0305Z" stroke="#a2d13f"/></svg>`;

interface ReadOnlyOptions {
    rating: number;
    spacing?: string;
    starWidth?: string;
}

interface RatingOptions {
    onSet: () => void;
}

function renderReadOnlyRating(el: HTMLElement, options: ReadOnlyOptions) {
    if (options && options.rating) {
        RateYo(el, {
            readOnly: true,
            normalFill,
            ratedFill,
            spacing: '2px',
            starWidth: '16px',
            starSvg,
            ...options,
        });
    }
    el.classList.add('disabled');
}

function renderRatingStars(el: HTMLElement, options: RatingOptions) {
    RateYo(el, {
        spacing: '8px',
        starWidth: '30px',
        maxValue: 5,
        precision: 1,
        halfStar: true,
        normalFill,
        ratedFill,
        starSvg,
        onSet: options.onSet,
    });
}

export { renderReadOnlyRating, renderRatingStars };
